// extracted by mini-css-extract-plugin
export default {"x":"styles_x__-axJm","x_small":"styles_x_small__hBsxt","x_light":"styles_x_light__A21pj"};